// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"hK-z","smallCardRow":"iK-z","largeCardRow":"jK-z","productSearchRow":"kK-z","curatedRow":"lK-z"};